import React from 'react';
import './Input.css';

export default function Input({ 
  label, 
  error, 
  icon, 
  className = '', 
  ...props 
}) {
  return (
    <div className={`ui-form-group ${className}`}>
      {label && <label className="ui-label">{label}</label>}
      
      <div className={`ui-input-wrapper ${error ? 'has-error' : ''} ${props.disabled ? 'is-disabled' : ''}`}>
        {icon && <i className={`${icon} ui-input-icon`}></i>}
        
        <input 
          className="ui-input" 
          {...props} 
        />
      </div>
      
      {error && <span className="ui-error-msg">{error}</span>}
    </div>
  );
}
